import type { InputProps as InputPropsDefault } from '@vgn-medien-holding/vgn-fe-components';
import { composeStyles, Input as DefaultInput } from '@vgn-medien-holding/vgn-fe-components';
import borderedStyle from './styles/bordered';
import filledStyle from './styles/filled';

export interface InputProps extends InputPropsDefault {
  inputStyle?: 'bordered' | 'filled';
}

export const Input = ({ classProps, label, id, inputStyle = 'filled', inputProps, errorMessage }: InputProps) => {
  const styles = composeStyles(inputStyle === 'bordered' ? borderedStyle : filledStyle, classProps);
  return <DefaultInput label={label} id={id} inputProps={inputProps} errorMessage={errorMessage} classProps={styles} />;
};
